// src/pages/CustomerDueReport/components/exportCustomerDueReportCsv.js
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.report    - rows from Redux state.customerDueReport.report
 * @param {object}  params.authInfo  - for Pharmacy columns
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportCustomerDueReportCsv = ({
  report,
  authInfo,
  title = "Customer Due Invoice Wise Report",
  filename = "customer_due_invoice_wise",
}) => {
  const isPharmacy = authInfo?.branch_company_type === "Pharmacy";

  const headers = [
    "No.", "Voucher No", "Bill Amount", "Paid Amount Invoice",
    "Paid Amount", "Balances Due Amount",
    ...(isPharmacy ? ["Insurance Amount", "Insurance Amount Paid"] : []),
  ].map(escape);

  const dataRows = report.map((row, i) => [
    i + 1,
    row.voucher_no                  || "",
    format(parseFloat(row.total_amount              || 0).toFixed(2)),
    format(parseFloat(row.paid_amount               || 0).toFixed(2)),
    format(parseFloat(row.partialPaid               || 0).toFixed(2)),
    format(parseFloat(row.due                       || 0).toFixed(2)),
    ...(isPharmacy ? [
      format(parseFloat(row.insurance_amount          || 0).toFixed(2)),
      format(parseFloat(row.insurance_amount_received || 0).toFixed(2)),
    ] : []),
  ].map(escape));

  const totals = report.reduce((acc, row) => ({
    total_amount:               acc.total_amount               + parseFloat(row.total_amount               || 0),
    paid_amount:                acc.paid_amount                + parseFloat(row.paid_amount                || 0),
    partialPaid:                acc.partialPaid                + parseFloat(row.partialPaid                || 0),
    due:                        acc.due                        + parseFloat(row.due                        || 0),
    insurance_amount:           acc.insurance_amount           + parseFloat(row.insurance_amount           || 0),
    insurance_amount_received:  acc.insurance_amount_received  + parseFloat(row.insurance_amount_received  || 0),
  }), { total_amount: 0, paid_amount: 0, partialPaid: 0, due: 0,
        insurance_amount: 0, insurance_amount_received: 0 });

  const totalRow = [
    "Grand Total", "",
    format(totals.total_amount.toFixed(2)),
    format(totals.paid_amount.toFixed(2)),
    format(totals.partialPaid.toFixed(2)),
    format(totals.due.toFixed(2)),
    ...(isPharmacy ? [
      format(totals.insurance_amount.toFixed(2)),
      format(totals.insurance_amount_received.toFixed(2)),
    ] : []),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};